import { useMemo } from 'react';
import { htmlToText } from 'html-to-text';
import useNarrative from '@/pages/Narrative/hooks/useNarrative';

export const useDescription = () => {
  const {
    data: { keyTakeaways },
  } = useNarrative();
  return useMemo(() => {
    if (!keyTakeaways) return '';
    const text = htmlToText(keyTakeaways, {
      wordwrap: false,
      ignoreHref: true,
      selectors: [
        {
          selector: 'ul',
          format: 'unorderedList',
          options: {
            itemPrefix: ' ',
          },
        },
        {
          selector: 'a',
          format: 'anchor',
          options: {
            ignoreHref: true,
          },
        },
      ],
    });
    return text.split('\n')[0];
  }, [keyTakeaways]);
};
